import { useState } from 'react';
import { X } from 'lucide-react';
import { Input } from '@/components/ui/Input';

interface KeywordChipsProps {
  label: string;
  value: string[] | undefined;
  onChange: (value: string[] | undefined) => void;
  placeholder: string;
}

function KeywordChips({ label, value, onChange, placeholder }: KeywordChipsProps) {
  const [draft, setDraft] = useState('');
  const chips = value || [];

  const addChip = () => {
    const existentes = new Set(chips.map((c) => c.toLowerCase()));
    const novos: string[] = [];
    for (const parte of draft.split(/[,;]/)) {
      const termo = parte.trim();
      if (!termo || existentes.has(termo.toLowerCase())) continue;
      existentes.add(termo.toLowerCase());
      novos.push(termo);
    }
    if (novos.length > 0) {
      onChange([...chips, ...novos]);
    }
    setDraft('');
  };

  const removeChip = (termo: string) => {
    const next = chips.filter((c) => c !== termo);
    onChange(next.length > 0 ? next : undefined);
  };

  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs font-medium text-ds-text-secondary">{label}</label>
      <Input
        placeholder={placeholder}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            addChip();
          }
        }}
        onBlur={addChip}
      />
      {chips.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-1">
          {chips.map((termo) => (
            <span
              key={termo}
              className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs bg-ds-surface2 text-ds-text-secondary border border-ds-border"
            >
              {termo}
              <button
                type="button"
                onClick={() => removeChip(termo)}
                aria-label={`Remover ${termo}`}
                className="hover:text-ds-danger"
              >
                <X className="h-3 w-3" />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export { KeywordChips };
